import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import axiosInstance from '../../../../../services/AxiosInstance';
import Api from '../../../../../constants/Api';

/**
 * Componente responsável por listar os fornecedores.
 */
const VendorSelect = (props) => {

  const { t } = useTranslation();
  const [entities, setEntities] = useState([]);

  useEffect(() => {
    
    function findAll() {
      setEntities([]);

      axiosInstance.get(Api.main.vendor)
        .then(response => {
          let entities = [];

          for (var i = 0; i < response.data.length; i++) {
            entities.push(
              {
                value: response.data[i].id,
                label: response.data[i].name
              }
            );

            setEntities(entities);
          }
        });
    }

    findAll();
  }, []);

  return (
    <CustomSelect options={entities} value={props.value} onChange={props.onChange} isClearable placeholder={t("select")} />
  )
}

export default VendorSelect;